<template>
  <div class="c-modal-board-create">
    <Modal v-model="options.active" @input="closeModal" :closable="true">
      <template v-slot:title>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 6H19M7 3H17M5 21H19C20.1046 21 21 20.1046 21 19V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V19C3 20.1046 3.89543 21 5 21Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-width="1.5"
          />
        </svg>

        <h3>Create Board</h3>
      </template>
      <template>
        <FormBoardCreate @onSubmit="onSubmit"></FormBoardCreate>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from './index.vue';
import FormBoardCreate from '@swipekit/components/form/form-board-create.vue';
export default {
  components: {
    Modal,
    FormBoardCreate,
  },

  data: function () {
    return {
      options: {
        name: 'modal-tracker-create',
        active: false,
      },
    };
  },

  watch: {
    'options.active': {
      handler: function () {},
    },
    addId: function () {
      if (this.addId) {
        this.options.active = true;
      } else {
        this.options.active = false;
      }
    },
  },

  computed: {
    addId: function () {
      return this.$store.getters['boards/addId'];
    },
  },

  methods: {
    onSubmit: function () {
      this.$store.dispatch('triggerExtension', { type: 'boards:update' });
      this.$store.dispatch('message/onBoardCreate');
      this.options.active = false;
    },
    activate: function () {
      this.options.active = true;
    },
    closeModal: function () {
      this.$store.dispatch('boards/setAdd', null);
    },
  },

  mounted: function () {
    //this.options.active = true;
  },
};
</script>

<style lang="scss">
.c-modal-board-create {
  .modal-content {
    overflow: hidden;
  }

  .modal {
    &__title {
      display: flex;
      align-items: center;
      padding: 16px var(--spacer);
      background-color: var(--color-bg-2);
      border-bottom: var(--color-bg-4) solid 1px;

      svg {
        width: 32px;
        height: 32px;
        margin-right: var(--margin-lg);
      }

      h3 {
        margin-bottom: 0;
      }
    }

    &__content {
      padding-top: var(--spacer-sm);
      padding-bottom: var(--spacer-sm);
      background-color: var(--color-bg-1);
    }

    &__footer {
      padding: 16px var(--spacer);
      background-color: var(--color-bg-2);
      border-top: var(--color-bg-4) solid 1px;
    }
  }
}
</style>
